import client from "@irati/utils/services/apollo"
import {QueryDealsArgs} from "@irati/types/ops"
import dealsQuery, {dealListQueryKey} from "./queries/dealList"

export const search = (params: any, options: any) => {
  const {limit, q, geo, slim, lat, lng, insideBoundingBox, radius, isRewards} = params
  const variables: QueryDealsArgs = {limit, q, geo, slim, lat, lng, radius, isRewards}

  if (params.boundingBox) {
    variables.insideBoundingBox = params.boundingBox
    variables.geo = true
    variables.slim = true
  }
  if (insideBoundingBox) {
    if (typeof insideBoundingBox === "string") {
      variables.insideBoundingBox = insideBoundingBox.split(",")
    } else {
      variables.insideBoundingBox = insideBoundingBox
    }
  }

  return client.query({query: dealsQuery, variables, ...options}).then(({data}) => {
    return {
      data: {
        results: {
          deals: data[dealListQueryKey].results,
          total: data[dealListQueryKey].total
        },
        q,
        lat,
        lng,
        radius,
        boundingBox: insideBoundingBox
      }
    }
  })
}
